import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Performance',
    [Tab.NewCustomers]: 'Nouveaux restaurants',
    [Tab.CustomerHealth]: 'Santé client',
    [Tab.LiveAndInactive]: 'Actifs et inactifs',
    [Tab.BillingHealth]: 'Santé de facturation',
  },
  labels: {
    sales_manager: 'Responsable commercial',
  },
  performance_tab: {
    table_columns: {
      name: 'Nom',
      sales_manager: 'Responsable commercial',
      orders: 'Commandes',
      sales: 'Ventes',
      previous_month_sales: 'Revenus du mois précédent',
    },
    labels: {
      sales_volume: 'Volume des ventes :',
      all: 'Tous',
      click_to_sort: 'Cliquer pour trier',
      no_data: 'Aucune donnée',
    },
    toasts: {
      failed_to_load_data: 'Échec du chargement des données',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Nom',
      sales_manager: 'Responsable commercial',
      orders: 'Commandes',
      sales: 'Ventes',
      days_live: 'Jours en ligne',
      early_performance: 'Performance initiale',
    },
    labels: {
      click_to_sort: 'Cliquer pour trier',
      no_data: 'Aucune donnée',
      only_with_early_performance: 'Uniquement avec performance initiale : ',
      early_performance_yes: '✔️ Oui',
      early_performance_no: '✗ Non',
    },
    toasts: {
      failed_to_load_data: 'Échec du chargement des données',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Niveaux de ventes',
      payments_ratio: 'Ratio de paiements',
    },
    dataset_labels: {
      negative: 'Négatif ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Bien ({{values}})',
      excellent: 'Excellent ({{values}})',
    },

    companies_preview_modal: {
      title: 'Aperçu des restaurants',
      table_columns: {
        name: 'Nom',
        sales_manager: 'Responsable commercial',
        orders: 'Commandes',
        sales: 'Ventes',
        total_payments: 'Total des paiements',
        payments_ratio: 'Ratio de paiements',
      },
      labels: {
        close: 'Fermer',
        click_to_sort: 'Cliquer pour trier',
        no_data: 'Aucune donnée',
      },
    },
    toasts: {
      failed_to_load_data: 'Échec du chargement des données',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'En ligne',
      no_orders: 'Aucune commande',
      no_conversion: 'Aucune conversion',
    },
    toasts: {
      failed_to_load_data: 'Échec du chargement des données',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Type de facturation',
        options: {
          [BillingTypeOptions.Subscription]: 'Abonnement',
          [BillingTypeOptions.Manual]: 'Autre',
        },
      },
      high_risk_only: {
        label: 'Clients à haut risque uniquement',
      },
    },
    fields: {
      name: 'Nom',
      live_from: 'En ligne depuis',
      billing_mode: {
        title: 'Source de facturation',
        options: {
          [BillingMode.Stripe]: 'Mode de paiement',
          [BillingMode.InternalInvoicing]: 'Ventes',
        },
      },
      trial_ends_at: "Fin d'essai",
      last_failed_invoice_amount: 'Montant de la dernière facture échouée',
      failed_payments_count: 'Nombre de paiements échoués',
    },
    tags: {
      is_high_billing_risk_customer: 'Risques de facturation élevés',
    },
    toasts: {
      failed_to_load_data: 'Échec du chargement des données',
    },
  },
};
